const VoucherTransactionValue = {
  PRICE: 1,
  PERCENT: 2
}
export default VoucherTransactionValue
